const products = [
  {
    id: 1,
    name: "Solar Inverter",
    category: "Inverters",
    description: "High efficiency inverter for residential and commercial use.",
    image: "https://tse3.mm.bing.net/th/id/OIP.tuWX7zURVYzFFZrZSG62CAHaEc?rs=1&pid=ImgDetMain&o=7&rm=3"
  },
  {
    id: 2,
    name: "Lithium Battery",
    category: "Batteries",
    description: "Long life battery with fast charging capability.",
    image: "https://tse1.mm.bing.net/th/id/OIP.OqGWWWQU0viG2px5OTBHQAHaHC?rs=1&pid=ImgDetMain&o=7&rm=3"
  },
  {
    id: 3,
    name: "Solar Panel",
    category: "Panels",
    description: "High power mono-crystalline solar panels.",
    image: "https://rewiredz.com/wp-content/uploads/2023/04/Solar-panel-system-design-and-planning-concept-1024x574.webp"
  },
  {
    id: 4,
    name: "Hybrid Solar System",
    category: "Solar Systems",
    description:
      "Integrated hybrid solar system combining panels, inverter, and battery storage.",
    image: "https://tse3.mm.bing.net/th/id/OIP.fZVqyHIcsiBSqFRIDyBKhQHaHa?rs=1&pid=ImgDetMain&o=7&rm=3"
  },
  {
    id: 5,
    name: "EV Charging Station",
    category: "EV Solutions",
    description:
      "Smart electric vehicle charging station for residential and commercial use.",
    image: "https://spectrum.ieee.org/media-library/less-than-p-greater-than-electric-vehicle-charging-stations-in-monterey-park-calif-less-than-p-greater-than.jpg?id=32246419"
  },
  {
    id: 6,
    name: "Solar Water Heater",
    category: "Heating Solutions",
    description:
      "Energy-efficient solar water heating system for homes and industries.",
    image: "https://www.treehugger.com/thmb/orOvMANYkD-t9RuQmzceicoEZBQ=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/water-boiler-with-solar-panels-on-roof-of-house-588255272-676fafb3bbe44108b6588b0dc2785a2c.jpg"
  }
];

export default products;
